<template>
  <div style="display: flex; align-items: flex-start;">
    <sidebar style="margin-right: 20px; max-width: 200px" />
    <el-card style="width: 100%">
      <div
          slot="header"
          class="clearfix"
      >
        <span>Bizonylat beérkeztetések - számlák</span>
        <div class="" style="float: right">
          <el-button
              style="margin-top: -5px;"
              type="success"
              size="small"
              @click="$router.replace('/representative-processes/receipt-receives/invoice/add/second')"
              icon="el-icon-plus"
              v-can="'receiptreceives.create'"
          >
            Második pld. beérk.
          </el-button>
          <el-button
              style="margin-top: -5px; margin-left: 10px;"
              type="success"
              size="small"
              @click="$router.replace('/representative-processes/receipt-receives/invoice/add/third')"
              icon="el-icon-plus"
              v-can="'receiptreceives.create'"
          >
            Harmadik pld. beérk.
          </el-button>
        </div>
      </div>
      <div v-loading="loading" style="min-height: 81px;">
        <table-filter
            v-if="filterConfig"
            :config="filterConfig"
            action="invoiceReceiptReceives/fetchAll"
        />
      </div>

      <invoice-receipt-receives-list />

      <template v-if="$route.meta.showAddInvoiceReceiptReceiveDialog">
        <invoice-receipt-receive-dialog
        />
      </template>

    </el-card>
  </div>

</template>

<script>
  import InvoiceReceiptReceivesList from '../../../components/representativeProcesses/receiptReceives/invoice/List';
  import InvoiceReceiptReceiveDialog from '../../../components/representativeProcesses/receiptReceives/invoice/Dialog'
  import TableFilter from '../../../components/TableFilter';
  import Sidebar from "../../../components/representativeProcesses/receiptReceives/Sidebar";

  export default {
    components: {
      Sidebar,
      InvoiceReceiptReceivesList,
      InvoiceReceiptReceiveDialog,
      TableFilter,
    },
    data() {
      return {
        loading: false,
        filterConfig: null,
      };
    },
    async mounted() {
      this.loading = true;
      await this.setConfig();
      this.loading = false;
    },
    methods: {
      async setConfig() {
        let users = this.$store.getters['user/users'];
        if (!users.length) {
          await this.$store.dispatch('user/fetchAll');
          users = this.$store.getters['user/users'];
        }

        this.filterConfig = [
          {
            type: 'text',
            name: 'receipt_number',
            label: 'Bizonylatszám',
            defaultSearch: true,
          },
          {
            type: 'multipleSelect',
            options: users,
            name: 'representativeUser',
            label: 'Képviselő',
            labelCallback: user => user && `${user.last_name} ${user.first_name} (@${user.username})` || '',
            valueKey: 'id',
          },
          {
            type: 'dateRange',
            name: 'daterange',
            label: 'Időszak',
          },
        ];
      },
    },
  };
</script>
